import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const PREVIOUS_PATH_KEY = 'prevPath';
export const usePreviousPath = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      sessionStorage.setItem(PREVIOUS_PATH_KEY, router.asPath);
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);
};
